export default __webpack_public_path__ + "static/media/1.75ee2f55.svg";